import React from "react";

const User = () => {
  return (
    <div className="profile-top-area">
      <label className="profile-label">User</label>
    </div>
  );
};

export default User;
